// Zusätzliche Übersetzungen (flache Schlüssel wie in de.js); wird in fieldMapping.js über die Basis-Sprachdateien gelegt.
// Live-Standort: Fahrer-App (ll_driver_*) und Kunden-Seite "Buchung verwalten" (ll_cust_*).
const de = {
  ll_driver_share_check: "Live-Standort mit dem Kunden teilen (optional)",
  ll_driver_privacy: "Ihr Standort wird nur während der Anfahrt und nur mit dem Kunden dieser Fahrt geteilt und nach der Abholung gelöscht.",
  ll_driver_share_btn: "Standort teilen",
  ll_driver_sharing: "Standort wird geteilt",
  ll_driver_stop_btn: "Teilen beenden",
  ll_driver_keep_open: "Bitte lassen Sie die App geöffnet und den Bildschirm eingeschaltet. Im Hintergrund stoppt das Teilen (besonders auf iPhones).",
  ll_driver_denied: "Standortfreigabe verweigert. Die Fahrt läuft trotzdem, der Kunde sieht Sie aber nicht live.",
  ll_driver_unsupported: "Dieses Gerät oder dieser Browser unterstützt keine Standortfreigabe.",
  ll_driver_error: "Standort derzeit nicht verfügbar. Es wird weiter versucht.",
  ll_driver_net_retry: "Verbindung unterbrochen. Senden wird automatisch wiederholt.",
  ll_driver_stopped_auto: "Die Standortfreigabe wurde beendet.",
  ll_driver_started_toast: "Standortfreigabe gestartet",
  ll_driver_start_failed: "Standortfreigabe konnte nicht gestartet werden.",
  ll_cust_title: "Live-Standort Ihres Fahrers",
  ll_cust_show_btn: "Fahrer auf Karte anzeigen",
  ll_cust_hide_btn: "Karte ausblenden",
  ll_cust_privacy: "Beim Anzeigen der Karte werden Kartenkacheln von OpenStreetMap geladen. Dabei wird Ihre IP-Adresse an den Kartenanbieter übertragen.",
  ll_cust_data_note: "Der Fahrer teilt seinen Standort freiwillig und nur während der Anfahrt. Er wird nach der Abholung gelöscht.",
  ll_cust_loading: "Karte wird geladen …",
  ll_cust_map_error: "Die Karte konnte nicht geladen werden.",
  ll_cust_eta: "Ihr Fahrer ist in ca. {min} Min bei Ihnen ({km} km)",
  ll_cust_eta_time: "Ankunft ca. {time} Uhr",
  ll_cust_arrived: "✅ Ihr Fahrer ist am Abholort angekommen.",
  ll_cust_walk_title: "Dem Fahrer entgegengehen – Route öffnen in:",
  ll_cust_route_google: "🧭 Google Maps (zu Fuß zum Fahrer)",
  ll_cust_route_apple: " Apple Karten (zu Fuß zum Fahrer)",
  ll_cust_route_pickup: "📍 Route zum Abholort",
  ll_cust_unavailable: "Der Live-Standort ist derzeit nicht verfügbar. Der Fahrer teilt ihn freiwillig und nur während der Anfahrt.",
  ll_cust_updated: "Zuletzt aktualisiert vor {s} Sekunden",
  ll_cust_driver_marker: "Fahrer",
  ll_cust_pickup_marker: "Abholort",
  ll_cust_session_expired: "Die Sitzung ist abgelaufen. Bitte laden Sie die Seite neu und bestätigen Sie Ihre Buchung erneut.",
};
const en = {
  ll_driver_share_check: "Share live location with the customer (optional)",
  ll_driver_privacy: "Your location is shared only during the approach, only with the customer of this trip, and is deleted after pickup.",
  ll_driver_share_btn: "Share location",
  ll_driver_sharing: "Location is being shared",
  ll_driver_stop_btn: "Stop sharing",
  ll_driver_keep_open: "Please keep the app open and the screen on. Sharing stops in the background (especially on iPhones).",
  ll_driver_denied: "Location permission denied. The trip continues, but the customer will not see you live.",
  ll_driver_unsupported: "This device or browser does not support location sharing.",
  ll_driver_error: "Location currently unavailable. Still trying.",
  ll_driver_net_retry: "Connection lost. Sending will be retried automatically.",
  ll_driver_stopped_auto: "Location sharing has ended.",
  ll_driver_started_toast: "Location sharing started",
  ll_driver_start_failed: "Location sharing could not be started.",
  ll_cust_title: "Live location of your driver",
  ll_cust_show_btn: "Show driver on map",
  ll_cust_hide_btn: "Hide map",
  ll_cust_privacy: "Showing the map loads map tiles from OpenStreetMap. In doing so, your IP address is transmitted to the map provider.",
  ll_cust_data_note: "The driver shares their location voluntarily and only during the approach. It is deleted after pickup.",
  ll_cust_loading: "Loading map …",
  ll_cust_map_error: "The map could not be loaded.",
  ll_cust_eta: "Your driver will be with you in about {min} min ({km} km)",
  ll_cust_eta_time: "arrival approx. {time}",
  ll_cust_arrived: "✅ Your driver has arrived at the pickup point.",
  ll_cust_walk_title: "Walk towards your driver – open route in:",
  ll_cust_route_google: "🧭 Google Maps (walk to driver)",
  ll_cust_route_apple: " Apple Maps (walk to driver)",
  ll_cust_route_pickup: "📍 Route to pickup point",
  ll_cust_unavailable: "The live location is currently unavailable. The driver shares it voluntarily and only during the approach.",
  ll_cust_updated: "Last updated {s} seconds ago",
  ll_cust_driver_marker: "Driver",
  ll_cust_pickup_marker: "Pickup location",
  ll_cust_session_expired: "The session has expired. Please reload the page and confirm your booking again.",
};
const tr = {
  ll_driver_share_check: "Canlı konumu müşteriyle paylaş (isteğe bağlı)",
  ll_driver_privacy: "Konumunuz yalnızca müşteriye yaklaşırken, yalnızca bu yolculuğun müşterisiyle paylaşılır ve alım sonrasında silinir.",
  ll_driver_share_btn: "Konumu paylaş",
  ll_driver_sharing: "Konum paylaşılıyor",
  ll_driver_stop_btn: "Paylaşımı durdur",
  ll_driver_keep_open: "Lütfen uygulamayı açık ve ekranı etkin tutun. Arka planda paylaşım durur (özellikle iPhone'larda).",
  ll_driver_denied: "Konum izni reddedildi. Yolculuk devam eder, ancak müşteri sizi canlı göremez.",
  ll_driver_unsupported: "Bu cihaz veya tarayıcı konum paylaşımını desteklemiyor.",
  ll_driver_error: "Konum şu anda kullanılamıyor. Denemeye devam ediliyor.",
  ll_driver_net_retry: "Bağlantı kesildi. Gönderme otomatik olarak tekrarlanacak.",
  ll_driver_stopped_auto: "Konum paylaşımı sona erdi.",
  ll_driver_started_toast: "Konum paylaşımı başlatıldı",
  ll_driver_start_failed: "Konum paylaşımı başlatılamadı.",
  ll_cust_title: "Sürücünüzün canlı konumu",
  ll_cust_show_btn: "Sürücüyü haritada göster",
  ll_cust_hide_btn: "Haritayı gizle",
  ll_cust_privacy: "Haritayı göstermek için OpenStreetMap'ten harita karoları yüklenir. Bu sırada IP adresiniz harita sağlayıcısına iletilir.",
  ll_cust_data_note: "Sürücü konumunu gönüllü olarak ve yalnızca yaklaşma sırasında paylaşır. Alım sonrasında silinir.",
  ll_cust_loading: "Harita yükleniyor …",
  ll_cust_map_error: "Harita yüklenemedi.",
  ll_cust_unavailable: "Canlı konum şu anda kullanılamıyor. Sürücü bunu gönüllü olarak ve yalnızca yaklaşma sırasında paylaşır.",
  ll_cust_updated: "Son güncelleme {s} saniye önce",
  ll_cust_driver_marker: "Sürücü",
  ll_cust_pickup_marker: "Alış noktası",
  ll_cust_session_expired: "Oturum süresi doldu. Lütfen sayfayı yenileyin ve rezervasyonunuzu yeniden doğrulayın.",
};
const pl = {
  ll_driver_share_check: "Udostępnij klientowi lokalizację na żywo (opcjonalnie)",
  ll_driver_privacy: "Twoja lokalizacja jest udostępniana tylko podczas dojazdu, tylko klientowi tego przejazdu i jest usuwana po odbiorze.",
  ll_driver_share_btn: "Udostępnij lokalizację",
  ll_driver_sharing: "Lokalizacja jest udostępniana",
  ll_driver_stop_btn: "Zakończ udostępnianie",
  ll_driver_keep_open: "Pozostaw aplikację otwartą i ekran włączony. W tle udostępnianie się zatrzymuje (zwłaszcza na iPhone'ach).",
  ll_driver_denied: "Odmówiono dostępu do lokalizacji. Przejazd trwa, ale klient nie zobaczy Cię na żywo.",
  ll_driver_unsupported: "To urządzenie lub przeglądarka nie obsługuje udostępniania lokalizacji.",
  ll_driver_error: "Lokalizacja jest obecnie niedostępna. Próby są ponawiane.",
  ll_driver_net_retry: "Utracono połączenie. Wysyłanie zostanie automatycznie ponowione.",
  ll_driver_stopped_auto: "Udostępnianie lokalizacji zostało zakończone.",
  ll_driver_started_toast: "Udostępnianie lokalizacji rozpoczęte",
  ll_driver_start_failed: "Nie udało się rozpocząć udostępniania lokalizacji.",
  ll_cust_title: "Lokalizacja kierowcy na żywo",
  ll_cust_show_btn: "Pokaż kierowcę na mapie",
  ll_cust_hide_btn: "Ukryj mapę",
  ll_cust_privacy: "Wyświetlenie mapy powoduje pobranie kafelków map z OpenStreetMap. Twój adres IP zostanie przy tym przesłany dostawcy map.",
  ll_cust_data_note: "Kierowca udostępnia lokalizację dobrowolnie i tylko podczas dojazdu. Po odbiorze jest ona usuwana.",
  ll_cust_loading: "Ładowanie mapy …",
  ll_cust_map_error: "Nie udało się załadować mapy.",
  ll_cust_unavailable: "Lokalizacja na żywo jest obecnie niedostępna. Kierowca udostępnia ją dobrowolnie i tylko podczas dojazdu.",
  ll_cust_updated: "Ostatnia aktualizacja {s} s temu",
  ll_cust_driver_marker: "Kierowca",
  ll_cust_pickup_marker: "Miejsce odbioru",
  ll_cust_session_expired: "Sesja wygasła. Odśwież stronę i ponownie potwierdź rezerwację.",
};
const uk = {
  ll_driver_share_check: "Ділитися місцезнаходженням наживо з клієнтом (необов'язково)",
  ll_driver_privacy: "Ваше місцезнаходження передається лише під час під'їзду, лише клієнту цієї поїздки та видаляється після посадки.",
  ll_driver_share_btn: "Поділитися місцезнаходженням",
  ll_driver_sharing: "Місцезнаходження передається",
  ll_driver_stop_btn: "Припинити передачу",
  ll_driver_keep_open: "Залишайте застосунок відкритим, а екран увімкненим. У фоновому режимі передача зупиняється (особливо на iPhone).",
  ll_driver_denied: "Доступ до місцезнаходження відхилено. Поїздка триває, але клієнт не бачитиме вас наживо.",
  ll_driver_unsupported: "Цей пристрій або браузер не підтримує передачу місцезнаходження.",
  ll_driver_error: "Місцезнаходження зараз недоступне. Спроби тривають.",
  ll_driver_net_retry: "З'єднання втрачено. Надсилання буде автоматично повторено.",
  ll_driver_stopped_auto: "Передачу місцезнаходження завершено.",
  ll_driver_started_toast: "Передачу місцезнаходження розпочато",
  ll_driver_start_failed: "Не вдалося розпочати передачу місцезнаходження.",
  ll_cust_title: "Місцезнаходження водія наживо",
  ll_cust_show_btn: "Показати водія на карті",
  ll_cust_hide_btn: "Сховати карту",
  ll_cust_privacy: "Під час показу карти завантажуються фрагменти карти з OpenStreetMap. При цьому ваша IP-адреса передається постачальнику карт.",
  ll_cust_data_note: "Водій передає місцезнаходження добровільно і лише під час під'їзду. Після посадки воно видаляється.",
  ll_cust_loading: "Завантаження карти …",
  ll_cust_map_error: "Не вдалося завантажити карту.",
  ll_cust_unavailable: "Місцезнаходження наживо зараз недоступне. Водій передає його добровільно і лише під час під'їзду.",
  ll_cust_updated: "Оновлено {s} с тому",
  ll_cust_driver_marker: "Водій",
  ll_cust_pickup_marker: "Місце посадки",
  ll_cust_session_expired: "Сесія завершилася. Перезавантажте сторінку та підтвердьте бронювання ще раз.",
};
const all = { de, en, tr, pl, uk };
export default all;
